import { render, staticRenderFns } from "./minerepwd.vue?vue&type=template&id=5b2aa324&"
import script from "./minerepwd.vue?vue&type=script&lang=js&"
export * from "./minerepwd.vue?vue&type=script&lang=js&"
import style0 from "./minerepwd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports